import { Component, Input } from "@angular/core";

@Component({
  selector: "app-avatar-uploader",
  templateUrl: "./avatar-uploader.component.html",
  styleUrls: ["./avatar-uploader.component.scss"],
  standalone: false,
})
export class AvatarUploaderComponent {
  @Input() avatarUploadUrl: string;
  @Input() thumbnailPhotoUrl: string;
  @Input() localAvatar: boolean;
}
